import AService from '@/services/AService'

const ENTITY_NAME = 'planning';

export default class PlanningService extends AService {
  async fetchByOffice(officeId) {
    const response = await this.http.get(`${this.baseUrl}/${ENTITY_NAME}/office/${officeId}`)
    return response.data
  }
}
